/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { Capa } from '../../components/Capa';
import { useStartupState } from '../../Providers/StartupState';
import { handleGetData } from '../../Api';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import * as S from './style';
import { Loading } from '../../components/Loading';


export const PrivacyPolicy = () => {
  const [data, setData] = useState(null);
  const { setTitle, setBgHeader } = useHeaderStates();
  const [selectedOption, setSelectedOption] = useState(0); // Nenhum aberto inicialmente
  const { token, setError, loading, setLoading } = useStartupState();

  useEffect(() => {
    setError(null);
    setLoading(true);

    if (token) {
      handleGetData(token, "/api/content/copasul/politicaprivacidade/")
        .then((response) => {
          setData(response?.data?.items[0]?.data);

          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  // A Capa desenha o título: a faixa verde do Header fica desligada.
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  const handleActionButton = (index) => {
    setSelectedOption(index); // Mantém o último clicado ativo
  };

  if(loading){
  return <Loading />
}
if(data){
  return (
    <>
      <Capa
        imagem={data?.imagemHeader?.iv?.[0]}
        titulo={data?.seo?.iv?.TituloSEO}
      />

      <S.Container bgPrivacyPolicy={data?.imagemFundo?.iv[0]}>
        <S.AbasContainer>
          <S.Head>
            {data?.informacoesPrivacidade?.iv.map((item, index) => (
              <S.ListaItem
                key={index}
                onClick={() => handleActionButton(index)}
                className={selectedOption === index ? "ativo" : ""}
              >
                {item.tituloMarkdown}
              </S.ListaItem>
            ))}
          </S.Head>
        </S.AbasContainer>

        {/* Exibir apenas se houver algo selecionado */}
        {selectedOption !== null && (
          <ReactMarkdown className="ReactMarkdown">
            {data?.informacoesPrivacidade?.iv[selectedOption]?.descricaoMarkdown}
          </ReactMarkdown>
        )}
      </S.Container>
    </>
  )};
};
